import configStore from "../../stores/ConfigStore";

import { AddonRuntimeInfo } from "../../domain/api/addons/AddonRuntimeInfo";
import responseHandler from "../health/responseHandler";


export default class MeetingAddonsDataService {

    public static async getAddonsRuntimeInfoAsync(): Promise<AddonRuntimeInfo[]> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/meetingAddons`, {
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(e => e.json())
    }

    public static async getAddonRuntimeInfoAsync(addonIdentifier: string): Promise<AddonRuntimeInfo> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/meetingAddons/${addonIdentifier}`, {
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(e => e.json())
        .catch((e: Response) => responseHandler.onError(e));
    }
}
